import React, { ReactNode } from 'react';
import * as styles from './BannerActions.module.scss';

type BannerActionsProps = {
  children: ReactNode;
  className?: string;
};

export const BannerActions = ({ children, className }: BannerActionsProps) => {
  const classNames = `${styles.BannerActionsContainer} ${className}`;

  return <div className={classNames}>{children}</div>;
};
